<template>
    <div class="row">
        <div class="form-group col-12">
            <label for="sku">SKU</label>
            <input
                id="sku"
                v-model="variant.sku"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('sku')
                }"
                dir="auto"
                placeholder="SKU"
            />
            <div class="invalid-feedback">
                {{ getError('sku') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label>
                Gallery
            </label>
            <media-chooser v-model="variant.gallery" type="image" multiple />
        </div>

        <div class="form-group col-6">
            <label for="stockAmount">Stock Amount</label>
            <input
                id="stockAmount"
                v-model="variant.stockAmount"
                type="number"
                class="form-control"
                :disabled="editMode"
                :class="{
                    'is-invalid': hasError('stockAmount')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('stockAmount') }}
            </div>
        </div>
        <div v-if="editMode" class="col-2 d-flex align-items-end form-group">
            <button v-b-modal.change-stock-amount-modal class="btn btn-success">
                Change Amount
            </button>
        </div>

        <div class="form-group col-6">
            <label>Manage price </label>
            <b-form-checkbox v-model="managePrice" switch />
        </div>

        <template v-if="managePrice">
            <div class="form-group col-12">
                <label for="price">Price</label>
                <currency-input
                    id="price"
                    v-model="variant.price"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('price')
                    }"
                />
                <div class="invalid-feedback">
                    {{ getError('price') }}
                </div>
            </div>

            <div class="form-group col-12">
                <label>Add another price for Aguda members</label>
                <b-form-checkbox v-model="isAgudaPriceEnabled" switch />
            </div>
            <div v-if="isAgudaPriceEnabled" class="form-group col-12">
                <label for="agudaPrice">Aguda members price</label>
                <currency-input
                    id="agudaPrice"
                    v-model="variant.agudaPrice"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('agudaPrice')
                    }"
                />
                <div class="invalid-feedback">
                    {{ getError('agudaPrice') }}
                </div>
            </div>
        </template>
        <div v-if="!editMode" class="attributes mt-3 col-12">
            <h5>
                Attributes
            </h5>
            <div class="error-box mb-2">
                {{ getError('attributes') }}
            </div>
            <attributes-selector @change="variant.attributes = $event" />
        </div>

        <change-stock-amount-modal
            v-if="editMode"
            :item-id="variant.id"
            action-name="productVariants/changeStockAmount"
            @amount-updated="variant.stockAmount = $event"
        />
    </div>
</template>

<script>
import CurrencyInput from '@/components/elements/CurrencyInput';
import AttributesSelector from '@/components/attributes/Selector';
import ChangeStockAmountModal from '@/components/elements/ChangeStockAmountModal';

export default {
    components: {
        CurrencyInput,
        AttributesSelector,
        ChangeStockAmountModal
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            variant: {},
            managePrice: false,
            isAgudaPriceEnabled: false
        };
    },

    watch: {
        variant() {
            this.$emit('input', this.variant);
        },

        managePrice(val) {
            this.variant.price = val ? this.variant.price || 0 : null;
        },

        isAgudaPriceEnabled(value) {
            this.variant.agudaPrice = value
                ? this.variant.agudaPrice || 0
                : null;
        }
    },

    created() {
        this.variant = { ...this.value };
        this.managePrice = this.variant.price !== null;
        this.isAgudaPriceEnabled = this.editMode
            ? this.variant.agudaPrice !== null
            : false;
    },

    methods: {
        hasError(key) {
            return (
                this.validation.variant[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.variant,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
